import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import { LmsLiveQuizStudentAPIServiceV1 } from '@protos/learning_management/lms.liveQuiz.student.apis_connect';
import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';

export const LmsLiveQuizStudentAPIServiceV1Client =
  createPromiseClient(LmsLiveQuizStudentAPIServiceV1, lmsTransport);

export const useLmsLiveQuizStudentAPIServiceV1ClientWithStatusCodeHandler =
  (
    options: Partial<ConnectTransportOptions>,
    responseStatusCodeFunction: ResponseStatusCodeFunction
  ) =>
    createPromiseClient(
      LmsLiveQuizStudentAPIServiceV1,
      lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
    );
